import ThreeColumnImageSimpleRepository from "../ThreeColumnImageSimpleRepository"

export default class ContactThreeColumnImageSimple extends ThreeColumnImageSimpleRepository {
    static schemaId = "contact_us_threeColumnImage"

    constructor() {
        super(ContactThreeColumnImageSimple.schemaId)
    }
}
